import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { BackupLenderGlobalNav } from '~/backup/lender/domains/page/ui/BackupLenderGlobalNav';
import { AppHeader } from '~/packages/common-frontend/layout/Header';

type Props = { children: React.ReactNode };
export const BackupLenderTemplate = ({
  children,
}: Props): React.ReactElement => {
  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        <BackupLenderGlobalNav />
        <Box width="100%" overflowX="auto">
          {children}
        </Box>
      </Flex>
    </>
  );
};
